// extracted by mini-css-extract-plugin
export default {"content":"Kqos_G56Jutdz9QcfkKC"};